import React from 'react';
import PropTypes from 'prop-types';
import { InternalGrid, SkeletonItem } from '@paygreen/paygreen-ui';
import { CardClassic, ErrorBoundary } from '../../../components';
import { IsMobile } from '../../../utils/tools';

/**
 * @description - card to display customly user info with LineKeyValue component
 */
const CardInfo = ({
    isLoading,
    children,
    title,
    actionIcon,
    hasInput,
    button,
    alignItems,
}) => (
    <ErrorBoundary>
        <SkeletonItem
            blockHeight="auto"
            colorWab="grey10"
            radiusSize="sm"
            isLoading={isLoading}
        >
            <CardClassic
                title={title}
                isShadowWab={true}
                titleSize="md"
                actionIcon={actionIcon}
            >
                <InternalGrid
                    displayType="grid"
                    gridTemplateColumns={IsMobile() ? '1fr' : 'auto 1fr'}
                    justifyItems={hasInput ? 'stretch' : 'start'}
                    alignItems={alignItems}
                    gridGap="sm"
                    childrenMarginTop="none"
                    childrenMarginBottom="none"
                >
                    {children}
                </InternalGrid>

                {button}
            </CardClassic>
        </SkeletonItem>
    </ErrorBoundary>
);

CardInfo.propTypes = {
    isLoading: PropTypes.bool,
    title: PropTypes.string,
    actionIcon: PropTypes.object,
    hasInput: PropTypes.bool,
    button: PropTypes.element,
    alignItems: PropTypes.string,
};

CardInfo.defaultProps = {
    isLoading: false,
    hasInput: false,
    button: null,
    alignItems: 'center',
};

export default CardInfo;
